import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    groupFilterData: []
}
const GroupFilterSlice = createSlice({
    name: 'groupFilterFields',
    initialState,
    reducers: {
        handleGroupFilterData(state, action) {
            state.groupFilterData = action.payload
        }
    }
})

export const { handleGroupFilterData } = GroupFilterSlice.actions
export default GroupFilterSlice.reducer